import { connectedStore } from '../../store';
import selectors from '../selectors';

const getLocale = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getLocale(state);
};

export default getLocale;
